import React from 'react'

import { PermissionChecker } from '../../session'
import ControlledModal from '../../../components/modals/ControlledModal'
import EditUserForm from './EditUserForm'
import ModalHeader from './ModalHeader'
import UserLoader from './_load/UserLoader'

const EditUserModal = props => {
  return (
    <ControlledModal width="42rem" disableClickOutside {...props}>
      <PermissionChecker any={['changePassword']}>
        <UserLoader>
          <ModalHeader />
          <EditUserForm />
        </UserLoader>
      </PermissionChecker>
    </ControlledModal>
  )
}

export default EditUserModal
